import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Form, Input, Spin } from 'antd';
import Modal from 'components/Modal';
import Text from 'components/Text';
import styled from 'styled-components';
import { getMessageError, IResponseDataBody } from 'services/response';
import ticketListApis from 'features/ticketList/services/apis';
import { IUnrevokeTicketBody } from 'features/ticketList/services/types/api';
import toast from 'utils/toast';

export type UnrevokedNoteRef = {
  open: (data?: IUnrevokeTicketBody, successCallback?: () => void | null) => void;
};

type Props = {};
const UnrevokedNoteModal = forwardRef<UnrevokedNoteRef, Props>((props, ref) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const successCallbackRef = useRef<(() => void) | null>(null);

  const [data, setData] = useState<IUnrevokeTicketBody>();

  const handleClose = () => {
    setData({
      billIds: [],
      staffId: '',
    });
    setVisible(false);
    form.resetFields();
  };

  const onFinish = async (values: any) => {
    if (!data) return;
    setLoading(true);
    try {
      const body: IUnrevokeTicketBody = {
        ...data,
        note: values?.note || '',
      };
      const res: IResponseDataBody<boolean> = await ticketListApis.unrevokeTicket(body);
      if (res.data.data) {
        toast.success('Unrevoked tickets successful!');
        handleClose();
        successCallbackRef.current?.();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Unrevoked tickets failed');
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    open: (data?: IUnrevokeTicketBody, successCallback?: () => void | null) => {
      if (data) {
        setData(data);
      }
      successCallbackRef.current = successCallback || null;
      setVisible(true);
    },
  }));

  return (
    <Modal
      visible={visible}
      modalTitle='Note for Unrevoking Ticket'
      showClose
      okTitle={'Accept'}
      noneFooterStyle
      containerPadding={1.5}
      disableOk={loading}
      onClose={handleClose}
      onSubmit={() => form.submit()}
      v2
      noneBodyStyle
      width={'900px'}
    >
      <Spin spinning={loading}>
        <WrapperForm className='v2' form={form} validateTrigger={['onSubmit']} onFinish={onFinish}>
          <Text textAlign='center' variant='CONTENT_2'>
            Please enter the reason for unrevoking this ticket
          </Text>
          <Form.Item
            name={'note'}
            rules={[{ required: true, message: 'Please input the reason for unrevoking this ticket!' }]}
          >
            <Input.TextArea className='TextArea' rows={5} placeholder='Type your reason here' />
          </Form.Item>
        </WrapperForm>
      </Spin>
    </Modal>
  );
});
UnrevokedNoteModal.displayName = 'UnrevokedNoteModal';
export default UnrevokedNoteModal;

const WrapperForm = styled(Form)`
  height: 40vh;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &.v2 {
    height: auto;
    .CONTENT_2 {
      color: #64748b;
      text-align: center;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    textarea {
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;
